export const SET_BANNER_FOR_INTERNET = 'SET_BANNER_FOR_INTERNET';
export const GET_TARIFFS_FOR_INTERNET = 'GET_TARIFFS_FOR_INTERNET';
export const SET_TARIFFS_FOR_INTERNET = 'SET_TARIFFS_FOR_INTERNET';
export const SET_TARIFFS_FOR_INTERNET_SELF_ORDER = 'SET_TARIFFS_FOR_INTERNET_SELF_ORDER';
